import React from "react";
import Breadcrumbs from "../../common-elements/breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import LineChart from "../../common-elements/chart/LineChart";

function OrganizationTrends() {
  const { t } = useTranslation();

  return (
    <div className="page-body">
      <Breadcrumbs
        mainTitle={t("OrganizationTrends")}
        parent={t("Reports")}
        parentLink={`${process.env.PUBLIC_URL}/reports`}
      />
      <LineChart />
    </div>
  );
}

export default OrganizationTrends;
